// extracted by mini-css-extract-plugin
export default {"textarea-block-root":"TextareaBlock_textarea-block-root__2CCBx","block":"TextareaBlock_block__bjQ+j","sm":"TextareaBlock_sm__ip7WL","label":"TextareaBlock_label__a1oip"};